import { parse, isWithinInterval } from "date-fns"

export const bannerStartDate = parse("2024-03-01", "yyyy-MM-dd", new Date()).getTime()
export const bannerEndDate = parse("2024-04-01", "yyyy-MM-dd", new Date()).getTime()

export function shouldDisplayBanner() {
  return isWithinInterval(new Date(), { start: bannerStartDate, end: bannerEndDate })
}
